import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import {
  motion,
  AnimatePresence,
} from "framer-motion";

import {
  Loader,
  MealsCard,
  Pagination,
} from "../components/utils";

import {
  Section,
  Fotter,
  Header,
} from "../components/layout";

import {
  getAllCategorys,
} from "../redux/actions/category";

import {
  getFilteredMealsWithSort,
} from "../redux/actions/meals";

import MealsFilter
  from "../components/MealsFilter";

import {
  FiSearch,
  FiRefreshCw,
  FiArrowDown,
} from "react-icons/fi";

import {
  BiRestaurant,
} from "react-icons/bi";


function AllResturentMeals() {
  const {
    t,
  } = useTranslation();

  const dispatch =
    useDispatch();


  /* =====================================
      PAGINATION
  ====================================== */

  const [
    page,
    setPage,
  ] = useState(0);


  const [
    limit,
  ] = useState(16);


  /* =====================================
      FILTERS
  ====================================== */

  const [
    filters,
    setFilters,
  ] = useState({
    search: "",
    categoryId: "",
    priceMin: "",
    priceMax: "",
    sortBy: "default",
  });


  /* =====================================
      REDUX
  ====================================== */

  const {
    isLoading,
    FilltermealsWithSort,
    FilterpaginationWithSort,
  } = useSelector(
    (state) =>
      state.Meals
  );


  const {
    AllCategorys,
  } = useSelector(
    (state) =>
      state.Categorys
  );


  /*
   * طريقة عرض الوجبات على الهاتف.
   *
   * one = عمود واحد
   * two = عمودان
   *
   * القيمة الافتراضية عمودان.
   */

  const mobileMealColumns =
    useSelector(
      (state) =>
        state.Layout
          ?.mobileMealColumns ||
        "two"
    );


  /* =====================================
      MOBILE DETECTION
  ====================================== */

  /*
   * نستخدم isMobile فقط لتحديد
   * هل MealsCard سيأخذ compact أم لا.
   *
   * Redux لا يجب أن يغير شكل الكرت
   * على الكمبيوتر.
   */

  const [
    isMobile,
    setIsMobile,
  ] = useState(() => {

    if (
      typeof window ===
      "undefined"
    ) {
      return false;
    }


    return (
      window.innerWidth <
      768
    );

  });


  useEffect(() => {

    const handleResize =
      () => {

        setIsMobile(
          window.innerWidth <
            768
        );

      };


    window.addEventListener(
      "resize",
      handleResize
    );


    handleResize();


    return () => {

      window.removeEventListener(
        "resize",
        handleResize
      );

    };

  }, []);


  /* =====================================
      FETCH MEALS
  ====================================== */

  useEffect(() => {

    dispatch(
      getFilteredMealsWithSort(
        page,
        limit,
        filters
      )
    );

  }, [
    page,
    limit,
    filters,
    dispatch,
  ]);


  /* =====================================
      FETCH CATEGORIES
  ====================================== */

  useEffect(() => {

    dispatch(
      getAllCategorys()
    );

  }, [
    dispatch,
  ]);


  /* =====================================
      PAGINATION DATA
  ====================================== */

  const totalPages =
    FilterpaginationWithSort
      ?.totalPages ||
    0;


  const totalItems =
    FilterpaginationWithSort
      ?.totalItems ||
    0;


  /* =====================================
      SAFE MEALS DATA
  ====================================== */

  const displayedMeals =
    Array.isArray(
      FilltermealsWithSort
    )
      ? FilltermealsWithSort
      : [];


  /* =====================================
      FILTER CHANGE
  ====================================== */

  const handleFilterChange =
    (newFilters) => {

      setFilters(
        newFilters
      );


      setPage(0);

    };


  /* =====================================
      RESET FILTERS
  ====================================== */

  const resetFilters =
    () => {

      handleFilterChange({
        search: "",
        categoryId: "",
        priceMin: "",
        priceMax: "",
        sortBy: "default",
      });

    };


  /* =====================================
      CARD MODE
  ====================================== */

  /*
   * compact يتم تفعيله فقط:
   *
   * 1- على الهاتف.
   * 2- عندما يكون الاختيار عمودين.
   *
   * في الكمبيوتر يبقى MealsCard
   * بشكله الطبيعي دائماً.
   */

  const compactCard =
    isMobile &&
    mobileMealColumns ===
      "two";


  return (
    <>
      {/* =====================================
          HEADER
      ====================================== */}

      <Header
        active={5}
        DropActive={5}
      />


      <main
        className="
          min-h-screen

          bg-back-primery
          dark:bg-back-darkprimery
        "
      >

        {/* =================================
            HERO
        ================================= */}

        <section
          className="
            relative

            overflow-hidden

            bg-color-2

            pt-36
            pb-20

            md:pt-44
            md:pb-28
          "
        >

          {/* =================================
              DECORATIVE CIRCLE
          ================================= */}

          <div
            className="
              absolute

              -top-40
              -end-32

              w-[460px]
              h-[460px]

              rounded-full

              border
              border-white/10

              pointer-events-none
            "
          />


          {/* =================================
              GOLD GLOW
          ================================= */}

          <div
            className="
              absolute

              top-10
              end-10

              w-[300px]
              h-[300px]

              rounded-full

              bg-color-1/15

              blur-[120px]

              pointer-events-none
            "
          />


          {/* =================================
              BOTTOM DECORATION
          ================================= */}

          <div
            className="
              absolute

              -bottom-52
              -start-28

              w-[400px]
              h-[400px]

              rounded-full

              border
              border-color-1/10

              pointer-events-none
            "
          />


          <div
            className="
              container

              relative
              z-10
            "
          >

            {/* =================================
                HERO CONTENT
            ================================= */}

            <motion.div
              initial={{
                opacity: 0,
                y: 30,
              }}

              animate={{
                opacity: 1,
                y: 0,
              }}

              transition={{
                duration: 0.7,
              }}

              className="
                max-w-4xl
              "
            >

              {/* =============================
                  EYEBROW
              ============================== */}

              <div
                className="
                  inline-flex

                  items-center

                  gap-3

                  mb-6
                "
              >

                <span
                  className="
                    w-12
                    h-[2px]

                    bg-color-1
                  "
                />


                <div
                  className="
                    flex

                    items-center

                    gap-2

                    text-color-1
                  "
                >

                  <BiRestaurant
                    className="
                      text-base
                    "
                  />


                  <span
                    className="
                      font-kufi

                      text-xs
                      md:text-sm
                    "
                  >
                    {t(
                      "Yaman menu"
                    )}
                  </span>

                </div>

              </div>


              {/* =============================
                  TITLE
              ============================== */}

              <h1
                className="
                  max-w-4xl

                  font-kufi
                  font-bold

                  text-white

                  text-[2.5rem]
                  leading-[1.45]

                  md:text-5xl

                  lg:text-[4rem]
                  lg:leading-[1.35]

                  mb-6
                "
              >
                {t(
                  "discover all Yaman dishes"
                )}
              </h1>


              {/* =============================
                  DESCRIPTION
              ============================== */}

              <p
                className="
                  max-w-2xl

                  font-kufi

                  text-sm
                  md:text-lg

                  leading-8
                  md:leading-9

                  text-white/70
                "
              >
                {t(
                  "all Yaman dishes description"
                )}
              </p>

            </motion.div>


            {/* =================================
                SCROLL DETAIL
            ================================= */}

            <motion.div
              initial={{
                opacity: 0,
                y: 15,
              }}

              animate={{
                opacity: 1,
                y: 0,
              }}

              transition={{
                duration: 0.7,
                delay: 0.2,
              }}

              className="
                flex

                items-center

                gap-4

                mt-10
                md:mt-12
              "
            >

              <div
                className="
                  flex

                  w-10
                  h-10

                  items-center
                  justify-center

                  rounded-full

                  border
                  border-white/15

                  text-color-1
                "
              >
                <FiArrowDown />
              </div>


              <span
                className="
                  font-kufi

                  text-[10px]
                  md:text-xs

                  text-white/45
                "
              >
                {t(
                  "browse Yaman dishes"
                )}
              </span>

            </motion.div>

          </div>


          {/* =================================
              BOTTOM GOLD LINE
          ================================= */}

          <div
            className="
              absolute

              bottom-0
              start-0

              w-28
              md:w-48

              h-[3px]

              bg-color-1
            "
          />

        </section>


        {/* =================================
            MEALS SECTION
        ================================= */}

        <section
          id="meals-section"

          className="
            relative

            overflow-hidden

            bg-back-secondary
            dark:bg-back-darkprimery
          "
        >

          {/* Decorative Glow */}

          <div
            className="
              absolute

              -top-40
              -end-40

              w-[400px]
              h-[400px]

              rounded-full

              bg-color-1/[0.06]

              blur-[120px]

              pointer-events-none
            "
          />


          {/* Decorative Circle */}

          <div
            className="
              absolute

              -bottom-44
              -start-40

              w-[380px]
              h-[380px]

              rounded-full

              border
              border-color-1/10

              pointer-events-none
            "
          />


          {isLoading &&
          displayedMeals.length ===
            0 ? (

            /* =============================
                FIRST LOAD
            ============================== */

            <div
              className="
                min-h-[50vh]

                flex
                items-center
                justify-center
              "
            >
              <Loader />
            </div>

          ) : (

            <Section>

              <div
                className="
                  container

                  relative
                  z-10

                  py-14
                  md:py-20
                  lg:py-24
                "
              >

                {/* =================================
                    FILTER
                ================================= */}

                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}

                  animate={{
                    opacity: 1,
                    y: 0,
                  }}

                  transition={{
                    duration: 0.5,
                  }}

                  className="
                    mb-9
                    md:mb-12
                  "
                >

                  <MealsFilter
                    onFilterChange={
                      handleFilterChange
                    }

                    categories={
                      AllCategorys ||
                      []
                    }

                    initialFilters={
                      filters
                    }
                  />

                </motion.div>


                {/* =================================
                    RESULTS TOOLBAR
                ================================= */}

                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}

                  animate={{
                    opacity: 1,
                    y: 0,
                  }}

                  transition={{
                    duration: 0.5,
                    delay: 0.05,
                  }}

                  className="
                    flex

                    items-center
                    justify-between

                    gap-4

                    pb-6
                    mb-8

                    border-b
                    border-color-2/10
                    dark:border-white/10
                  "
                >

                  {/* =============================
                      RESULTS COUNT
                  ============================== */}

                  <div
                    className="
                      flex

                      items-center

                      gap-4
                    "
                  >

                    <div
                      className="
                        flex

                        w-11
                        h-11

                        md:w-12
                        md:h-12

                        shrink-0

                        items-center
                        justify-center

                        rounded-2xl

                        bg-color-1/10

                        text-color-1
                      "
                    >
                      <BiRestaurant
                        className="
                          text-lg
                          md:text-xl
                        "
                      />
                    </div>


                    <div>

                      <span
                        className="
                          block

                          font-kufi

                          text-[9px]
                          md:text-xs

                          text-color-1

                          mb-1
                        "
                      >
                        {t(
                          "menu results"
                        )}
                      </span>


                      <p
                        className="
                          font-kufi

                          text-[10px]
                          sm:text-xs
                          md:text-sm

                          text-n-6
                          dark:text-tcolor-2
                        "
                      >

                        {t(
                          "showing"
                        )}


                        {" "}


                        <strong
                          className="
                            text-tcolor-4
                            dark:text-white
                          "
                        >
                          {
                            displayedMeals.length
                          }
                        </strong>


                        {" "}


                        {t(
                          "items"
                        )}


                        {totalItems >
                          0 && (

                          <>
                            {" "}

                            {t(
                              "from"
                            )}

                            {" "}

                            <strong
                              className="
                                text-color-1
                              "
                            >
                              {
                                totalItems
                              }
                            </strong>
                          </>

                        )}

                      </p>

                    </div>

                  </div>


                  {/* =================================
                      لا توجد أزرار Grid/List هنا.

                      اختيار العمود/العمودين
                      يتم من إعداد الهاتف العام.
                  ================================= */}

                </motion.div>


                {/* =================================
                    LOADING DURING FILTER
                ================================= */}

                {isLoading &&
                displayedMeals.length >
                  0 && (

                  <div
                    className="
                      flex

                      justify-center

                      mb-8
                    "
                  >
                    <Loader />
                  </div>

                )}


                {/* =================================
                    MEALS GRID
                ================================= */}

                {displayedMeals.length >
                0 ? (

                  <AnimatePresence
                    mode="wait"
                  >

                    <motion.div
                      key={`${mobileMealColumns}-${filters.sortBy}-${page}`}

                      initial={{
                        opacity: 0,
                      }}

                      animate={{
                        opacity: 1,
                      }}

                      exit={{
                        opacity: 0,
                      }}

                      transition={{
                        duration: 0.3,
                      }}

                      className={`
                        grid

                        ${
                          mobileMealColumns ===
                          "two"
                            ? `
                              grid-cols-2
                              gap-3
                            `
                            : `
                              grid-cols-1
                              gap-6
                            `
                        }

                        md:grid-cols-2
                        md:gap-7

                        lg:grid-cols-3
                        lg:gap-8
                      `}
                    >

                      {displayedMeals.map(
                        (
                          meal,
                          index
                        ) => (

                          <motion.div
                            key={
                              meal._id
                            }

                            initial={{
                              opacity: 0,
                              y: 25,
                            }}

                            animate={{
                              opacity: 1,
                              y: 0,
                            }}

                            transition={{
                              duration: 0.45,

                              delay:
                                Math.min(
                                  index *
                                    0.04,
                                  0.25
                                ),
                            }}

                            className="
                              min-w-0
                            "
                          >

                            <MealsCard
                              meals={
                                meal
                              }

                              compact={
                                compactCard
                              }
                            />

                          </motion.div>

                        )
                      )}

                    </motion.div>

                  </AnimatePresence>

                ) : (

                  /* =================================
                      EMPTY STATE
                  ================================= */

                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}

                    animate={{
                      opacity: 1,
                      y: 0,
                    }}

                    transition={{
                      duration: 0.5,
                    }}

                    className="
                      my-10

                      rounded-[2rem]

                      border
                      border-color-1/15

                      bg-back-primery
                      dark:bg-back-darksecondary

                      px-6
                      py-14

                      md:py-16

                      text-center
                    "
                  >

                    {/* Icon */}

                    <div
                      className="
                        flex

                        w-16
                        h-16

                        mx-auto
                        mb-5

                        items-center
                        justify-center

                        rounded-full

                        bg-color-1/10

                        text-color-1
                      "
                    >
                      <FiSearch
                        size={25}
                      />
                    </div>


                    {/* Title */}

                    <h2
                      className="
                        font-kufi
                        font-semibold

                        text-lg
                        md:text-2xl

                        text-tcolor-4
                        dark:text-white

                        mb-3
                      "
                    >
                      {t(
                        "no matching dishes"
                      )}
                    </h2>


                    {/* Description */}

                    <p
                      className="
                        max-w-lg

                        mx-auto

                        font-kufi

                        text-xs
                        md:text-sm

                        leading-7

                        text-n-6
                        dark:text-tcolor-2

                        mb-7
                      "
                    >
                      {t(
                        "try changing your search or filters"
                      )}
                    </p>


                    {/* Reset */}

                    <button
                      type="button"

                      onClick={
                        resetFilters
                      }

                      className="
                        inline-flex

                        min-h-[44px]

                        items-center
                        justify-center

                        gap-2

                        rounded-full

                        bg-color-1

                        px-6

                        font-kufi
                        font-medium

                        text-xs
                        md:text-sm

                        text-white

                        transition-all
                        duration-300

                        hover:bg-color-2

                        hover:-translate-y-1

                        hover:shadow-[0_12px_30px_rgba(68,37,20,0.16)]
                      "
                    >

                      <FiRefreshCw />

                      {t(
                        "reset filters"
                      )}

                    </button>

                  </motion.div>

                )}


                {/* =================================
                    PAGINATION
                ================================= */}

                {totalPages >
                  1 && (

                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}

                    whileInView={{
                      opacity: 1,
                      y: 0,
                    }}

                    viewport={{
                      once: true,
                    }}

                    className="
                      mt-14
                      md:mt-20
                    "
                  >

                    <Pagination
                      currentPage={
                        page
                      }

                      totalPages={
                        totalPages
                      }

                      setPage={
                        setPage
                      }
                    />

                  </motion.div>

                )}

              </div>

            </Section>

          )}

        </section>

      </main>


      {/* =====================================
          FOOTER
      ====================================== */}

      <Fotter />
    </>
  );
}


export default AllResturentMeals;